import ModalForm from '../../../shared/components/modal-form';

export default class InternshipRequest extends ModalForm {
  constructor() {
    super(...arguments);

    this.$confirmationElement = this.$element.find(
      '.internshipRequest-confirmation'
    );

    this.bindEvents();
  }

  handleModalHide() {
    if (this.formWasSuccessful) {
      window.Turbolinks.reload({keepScrollPosition: true});
    }

    super.handleModalHide();
  }

  handleFormSuccess() {
    this.$confirmationElement.show();

    super.handleFormSuccess(...arguments);
  }
}
